import React, { useEffect } from "react";
import { MdCheckCircle } from "@react-icons/all-files/md/MdCheckCircle";
import { useTranslation } from "react-i18next";
import { Dialog, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Transition from "@shared/transitionSlideUp";
import { DialogBody } from "./finish.styles";
import { KYC_STATUS_VARIANTS } from "constants/kycStatusVariants";

function Finish() {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const info = useSelector((state: any) => state.info.allData);

  useEffect(() => {
    // only if user comes through OTP login, allow KYC steps, else navigate user to home page
    if (!info?.customerId) {
      navigate("/", { replace: true });
    }
  }, []);

  return (
    <>
      <Dialog fullScreen open={true} TransitionComponent={Transition}>
        <DialogBody>
          <MdCheckCircle size={160} color={theme.palette.primary.main} />
          <Typography color="secondary" variant="h6">
            {t("kyc_complete", { defaultValue: "KYC Completed" })}
          </Typography>
          <Typography color="secondary">
            {info?.kycStatus === KYC_STATUS_VARIANTS.VERIFIED_NOT_SUBMITTED
              ? t("kyc_done_text_message2", {
                  defaultValue:
                    "KYC process completed! Your status will be updated shortly.",
                })
              : t("kyc_done_text", {
                  defaultValue:
                    "Thank you for completing your KYC.Please close this window",
                })}
          </Typography>
        </DialogBody>
      </Dialog>
    </>
  );
}

export default Finish;
